"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DEFAULT_SIZE = 30;
var CategoryIcon = react_1.default.memo(function (_a) {
    var path = _a.path, fill = _a.fill, size = _a.size;
    return (react_1.default.createElement("svg", { viewBox: "-2 -2 29 28", width: size !== null && size !== void 0 ? size : DEFAULT_SIZE, height: size !== null && size !== void 0 ? size : DEFAULT_SIZE },
        react_1.default.createElement("path", { fill: fill !== null && fill !== void 0 ? fill : "black", d: path })));
});
exports.default = CategoryIcon;
